// src/api/cashDrawer.js
import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders() {
  const token = null;
  return token
    ? {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
}

export async function getCashDrawer(params = {}) {
  const res = await axios.get(`${API}/cash-drawers`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function updateBeginCash(drawerId, denoms) {
  const res = await axios.put(
    `${API}/cash-drawers/${drawerId}/begin`,
    { denoms },
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}

export async function updateDrawerCount(drawerId, denoms) {
  const res = await axios.put(
    `${API}/cash-drawers/${drawerId}/count`,
    { denoms },
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}

export async function listCashDrawerHistory(params = {}) {
  const filteredParams = {};
  if (params.start) filteredParams.start = params.start;
  if (params.end) filteredParams.end = params.end;
  if (params.salon_id != null) filteredParams.salon_id = params.salon_id;
  const res = await axios.get(`${API}/cash-drawers/history`, {
    params: filteredParams,
    headers: authHeaders(),
  });
  return res.data;
}
